import { useField } from 'react-final-form';

import { useActions } from '../../../../../../hooks/useActions';
import { usePersonFields } from '../../../../../../hooks/usePersonFields';
import { IPerson } from '../../../../../../models/Person';
import { updateModalState } from '../../../../../../store/redux-slices/modals';
import { EDIT_MEMBER_MODAL_NAME } from '../../../../../../styledComponents/Modals/EditMemberModal/editMemberModal.const';
import { personToSearchPerson } from '../../../../../../utils/personHelpers';
import { PrimaryMemberDetailsFormFields } from './primaryMemberDetailsForm.models';

export const usePrimaryMemberDetailsForm = () => {
  const UpdateModalState = useActions(updateModalState);
  const birthOfDate = useField(PrimaryMemberDetailsFormFields.DateOfBirth);
  const { changeFields } = usePersonFields({
    fields: { Phone: PrimaryMemberDetailsFormFields.PhoneNumber },
  });
  const {
    input: { value: personId },
  } = useField(PrimaryMemberDetailsFormFields.PersonId);

  const onEditMemberHandler = () => {
    if (!personId) {
      return;
    }
    UpdateModalState([EDIT_MEMBER_MODAL_NAME, personId]);
  };

  const onEditedMemberHandler = (person: IPerson) => {
    changeFields(personToSearchPerson(person));
  };

  return {
    onEditMemberHandler,
    birthOfDate,
    memberLoaded: !!personId,
    onEditedMemberHandler,
  };
};
